import { useSelector } from 'react-redux';

import { DOWNLOAD_PART_FILES_PERMISSIONS } from 'constants/all';

import { sharedUserHasPermissionToDownloadFiles } from 'modules/common/chat/entities/reducer';
import { doesUserOwnPart } from 'modules/viewerPage/data/reducer';

import {
  getGroupMemberSupplierRoles,
  isSuperUserOrGroupAdmin,
} from 'store/session/selectors';

export const useCanDownloadPdf = () => {
  const doesUserOwnPartValue = useSelector(doesUserOwnPart);
  const doesSharedUserHaveDownloadPermission = useSelector(
    sharedUserHasPermissionToDownloadFiles,
  );
  const groupMemberSupplierRoles = useSelector(getGroupMemberSupplierRoles);
  const superUserOrGroupAdmin = useSelector(isSuperUserOrGroupAdmin);
  const groupMemberWithDownloadPermission =
    groupMemberSupplierRoles.downloadPartFiles ===
    DOWNLOAD_PART_FILES_PERMISSIONS.ACCESS;
  const userHasPermissionToDownload =
    groupMemberWithDownloadPermission || superUserOrGroupAdmin;

  return (
    (doesUserOwnPartValue || doesSharedUserHaveDownloadPermission) &&
    userHasPermissionToDownload
  );
};
